import { render, staticRenderFns } from "./informationDocuments.vue?vue&type=template&id=40218988&"
import script from "./informationDocuments.vue?vue&type=script&lang=js&"
export * from "./informationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports